import { Injectable, SecurityContext } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PolicyDetailsService } from '../my-insurance/policy-details.service';
import { ErrorRedirectionService } from '../error-service/error-redirection.service';
import { KubraLogin } from '@models/kubra-login';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { FileOpener } from '@ionic-native/file-opener';
import { Capacitor } from '@capacitor/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UrlValidationService } from '@services/document/url-validation.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentsDataService {
  private documentsDetails: any = {};
  private details = new BehaviorSubject<any>(this.documentsDetails);
  $documentsDetails = this.details.asObservable();

  private renewalPoliciesDocumentData = null;
  private renewalPoliciesDocumentList = new BehaviorSubject<any>(
    this.renewalPoliciesDocumentData
  );
  $renewalPoliciesDocumentData =
    this.renewalPoliciesDocumentList.asObservable();

  private hideCustomLoader = new BehaviorSubject<string>('');

  constructor(
    private policyDetailsService: PolicyDetailsService,
    private errorRedirectionService: ErrorRedirectionService,
    private domSanitizer: DomSanitizer,
    private http: HttpClient,
    private urlValidationService: UrlValidationService
  ) { }

  setCustomLoader(indexToHideLoader) {
    this.hideCustomLoader.next(indexToHideLoader);
  }
  getCustomLoader() {
    return this.hideCustomLoader.asObservable();
  }
  updateDocumentsDetails(documentsDetails: any) {
    this.details.next(documentsDetails);
  }

  addCustomLoaderClass(docLinkIndex, elementRef, customClass) {
    const ele = elementRef.nativeElement.querySelector(`.${customClass}-${docLinkIndex}`);
    if (ele) {
      ele.classList.add('custom_loader');
    }
  }
  removeCustomLoaderClass(docLinkIndex, elementRef, customClass) {
    const ele = elementRef.nativeElement.querySelector(`.${customClass}-${docLinkIndex}.custom_loader`);
    if (ele) {
      ele.classList.remove('custom_loader');
    }
  }

  updaterenewalPoliciesDocumentData(renewalPoliciesDocumentData: any) {
    this.renewalPoliciesDocumentList.next(renewalPoliciesDocumentData);
  }
  handlePopupBlocker(ref) {
    if (!ref || ref.closed || typeof ref.closed === 'undefined') {
      alert('Please turn off the popup blocker');
      return true;
    }
    return false;
  }

  isItIosDevice() {
    if (
      window.navigator.userAgent.match(/iPad/i) ||
      window.navigator.userAgent.match(/iPhone/i) ||
      window.navigator.userAgent.match('Mac OS')
    ) {
      return true;
    }
    return false;
  }

  getMimeType(byteArray) {
    let mimeType = '';
    if (
      byteArray.FileExt.indexOf('.JPG') > -1 ||
      byteArray.FileExt.indexOf('.JPEG') > -1
    ) {
      mimeType = 'image/jpeg';
    } else if (byteArray.FileExt.indexOf('.PNG') > -1) {
      mimeType = 'image/png';
    } else if (byteArray.FileExt.indexOf('.GIF') > -1) {
      mimeType = 'image/gif';
    } else if (byteArray.FileExt.indexOf('.PDF') > -1) {
      mimeType = 'application/pdf';
    }
    return mimeType;
  }
  getMimeTypeFromObjectKey(objKey) {
    let mimeType = '';
    if (
      objKey.indexOf('.JPG') > -1 ||
      objKey.indexOf('.JPEG') > -1
    ) {
      mimeType = 'image/jpeg';
    } else if (objKey.indexOf('.PNG') > -1) {
      mimeType = 'image/png';
    } else if (objKey.indexOf('.GIF') > -1) {
      mimeType = 'image/gif';
    } else if (objKey.indexOf('.PDF') > -1) {
      mimeType = 'application/pdf';
    }
    console.log(mimeType);
    return mimeType;
  }


  downloadDocumentWhenNativePlatform(fileName, byteArray, isDownload) {
    const htmlEncode = (str) => {
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    };

    try {
      const fullPath = `${fileName}${byteArray.FileExt}`;
      const mimeType = this.getMimeType(byteArray);
      const base64Data = `data:application/pdf;base64,${byteArray.ByteStream}`;

      Filesystem.writeFile({
        path: fullPath,
        data: base64Data,
        directory: Directory.Data,
        recursive: true,
      })
        .then((writeFileResult) => {
          const fileUri = writeFileResult.uri;
          if (!isDownload) {
            FileOpener.open(fileUri, mimeType);
          } else {
            FileOpener.showOpenWithDialog(fileUri, mimeType);
          }
        })
        .catch((error) => {
          const sanitizedMessage = htmlEncode(error?.message || "Write failed");
          console.log(`[Filesystem Error] ${sanitizedMessage}`);
        });

    } catch (error) {
      const sanitizedMessage = htmlEncode(error?.message || "Unexpected error");
      console.error(`[WriteFile Exception] ${sanitizedMessage}`);
    }
  }


  downloadDocumentWhenIOSDevice(windowRef, blob) {
    const url: any = window.URL.createObjectURL(blob);
    if (!this.handlePopupBlocker(windowRef)) {
      windowRef.location = url;
    }
  }
  downloadDocumentUsingByteArray(blob, fileName, windowRef) {
    if (this.isItIosDevice()) {
      this.downloadDocumentWhenIOSDevice(windowRef, blob);
    } else {
      saveAs(blob, fileName);
    }
  }

  // downloadDocumentUsingByteArray(byteArray, fileName, isDownload, windowRef, hideLoader?) {
  //   if (byteArray) {
  //     const blob = new Blob([this._base64ToArrayBuffer(byteArray.ByteStream)], {
  //       type: this.getMimeType(byteArray),
  //     });
  //     if (Capacitor.isNativePlatform()) {
  //       this.downloadDocumentWhenNativePlatform(fileName, byteArray, isDownload);
  //     } else if (this.isItIosDevice()) {
  //       this.downloadDocumentWhenIOSDevice(windowRef, blob);
  //     } else {
  //       saveAs(blob, `${fileName}${byteArray.FileExt}`);
  //     }
  //   }
  // }
  getPolicyDocumentData(refrenceId, documentId, fileName, isDownload, hideLoader?) {
    let windowRef;
    if (this.isItIosDevice()) {
      windowRef = window.open();
    }
    this.policyDetailsService.getDocumentById(documentId, refrenceId).subscribe(
      (response) => {
        this.downloadFile(response, windowRef, fileName, hideLoader);
        // this.downloadDocumentUsingByteArray(response, fileName, isDownload, windowRef, hideLoader);      
      },
      (error) => {
        this.setCustomLoaderFlag(hideLoader);
        if (error.status) {
          this.errorRedirectionService.redirect(error.status);
        }
      }
    );
  }

  getClaimDocumentData(policyNumber, refrenceId, documentId, fileName, isDownload, hideLoader?) {
    let windowRef;
    if (this.isItIosDevice()) {
      windowRef = window.open();
    }
    this.policyDetailsService.getDocumentByIdForClaim(policyNumber, refrenceId, documentId).subscribe(
      (response) => {
        this.downloadFile(response, windowRef, fileName, hideLoader);
        // this.downloadDocumentUsingByteArray(response, fileName, isDownload, windowRef, hideLoader);      
      },
      (error) => {
        this.setCustomLoaderFlag(hideLoader);
        if (error.status) {
          this.errorRedirectionService.redirect(error.status);
        }
      }
    );
  }

  downloadDocumentWhenIOSDeviceForPresignedUrl(windowRef, url) {
    if (this.urlValidationService.isApprovedRedirectUrl(url)) {
      if (!this.handlePopupBlocker(windowRef)) {
        windowRef.location = url;
      }
    }
  }

  downloadUsingBlob(url, fileName, hideLoader, windowRef) {
    if (this.urlValidationService.isApprovedRedirectUrl(url)) {
      this.http.get(url, { responseType: 'blob' }).subscribe(blob => {
        this.setCustomLoaderFlag(hideLoader);
        if (this.isItIosDevice()) {
          this.downloadDocumentWhenIOSDevice(windowRef, blob);
        } else {
          saveAs(blob, fileName);
        }
      })
    }
  }

  public downloadFile(response, windowRef, fileName, hideLoader) {
    if (Capacitor.isNativePlatform()) {
      // this.downloadDocumentWhenNativePlatform(fileName, byteArray, isDownload);
    }
    else {
      // console.log('`${fileName}${this.getMimeTypeFromObjectKey(response?.objectKey)}`', `${fileName}`, `${hideLoader}`)
      // saveAs(response?.presignedUrl, fileName);
      this.downloadUsingBlob(response?.presignedUrl, fileName, hideLoader, windowRef);
    }
  }

  _base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  kubraLoginRequest(request: KubraLogin) {
    if (this.urlValidationService.isApprovedRedirectUrl(request.url)) {
      const mapForm = document.createElement('form');
      mapForm.setAttribute('style', 'display: none');
      mapForm.target = '_blank';
      mapForm.method = 'POST';
      mapForm.action = this.domSanitizer.sanitize(
        SecurityContext.URL,
        request.url
      );

      const mapInput = document.createElement('input');
      mapInput.setAttribute('type', 'text');
      mapInput.setAttribute('name', 'TOKEN1');
      mapInput.setAttribute(
        'value',
        this.domSanitizer.sanitize(SecurityContext.HTML, request.token1)
      );
      mapForm.appendChild(mapInput);

      const mapInput2 = document.createElement('input');
      mapInput2.setAttribute('type', 'text');
      mapInput2.setAttribute('name', 'TOKEN2');
      mapInput2.setAttribute(
        'value',
        this.domSanitizer.sanitize(SecurityContext.HTML, request.token2)
      );
      mapForm.appendChild(mapInput2);

      const mapInput3 = document.createElement('input');
      mapInput3.setAttribute('type', 'text');
      mapInput3.setAttribute('name', 'cbValidation');
      mapInput3.setAttribute(
        'value',
        this.domSanitizer.sanitize(SecurityContext.HTML, request.cbValidation)
      );
      mapForm.appendChild(mapInput3);

      document.body.appendChild(mapForm);
      mapForm.submit();
      document.body.removeChild(mapForm);
    }
  }

  /**
   * Required to call the method to close the custom loader
  */
  setCustomLoaderFlag(indexToHideLoader) {
    if (indexToHideLoader) {
      this.setCustomLoader(indexToHideLoader);
    }
  }
  onSuccessResponseForPresigned(response, windowRef, indexToHideLoader) {
    this.setCustomLoaderFlag(indexToHideLoader);
    if (response) {
      if (this.urlValidationService.isApprovedRedirectUrl(response?.presignedUrl)) {
        if (this.isItIosDevice()) {
          if (!this.handlePopupBlocker(windowRef)) {
            windowRef.location = response?.presignedUrl;
          }
        } else {
          const windowNonIos = window.open(response?.presignedUrl, '_blank');
          this.handlePopupBlocker(windowNonIos);
        }
      }
    }
  }

  onSuccess(blob, windowRef, indexToHideLoader) {
    this.setCustomLoaderFlag(indexToHideLoader);
    const url: any = window.URL.createObjectURL(blob);
    if (this.urlValidationService.isApprovedRedirectUrl(url)) {
      if (this.isItIosDevice()) {
        if (!this.handlePopupBlocker(windowRef)) {
          windowRef.location = url;
        }
      } else {
        const windowNonIos = window.open(url, '_blank');
        this.handlePopupBlocker(windowNonIos);
      }
    }
  }

  onError(err, description, policyId, hideLoader) {
    this.setCustomLoaderFlag(hideLoader);
    if (err && err.error && err.error.Code === '965') {
      err.error.Message = err.error.Message.replace(
        'DOC_NAME',
        description
      );
    }
    this.errorRedirectionService.errorRedirectHandler(err, policyId);
  }
  viewDocument(
    documentId: string,
    policyId: string,
    documentType: string,
    date: string,
    description: string,
    indexToHideLoader?: string
  ) {
    if (Capacitor.isNativePlatform()) {
      this.getPolicyDocumentData(policyId,
        documentId,
        `${documentType}_${policyId}_${date}`,
        false,
        indexToHideLoader
      );
    } else {
      let windowRef;
      if (this.isItIosDevice()) {
        windowRef = window.open();
      }
      this.policyDetailsService.getDocumentById(documentId, policyId).subscribe((response) => {
        this.onSuccessResponseForPresigned(response, windowRef, indexToHideLoader);
      },
        (err) => {
          this.onError(err, description, policyId, indexToHideLoader);
        }
      );
    }
  }
}
